import Grid from '@mui/material/Grid';
import { AppErrorList } from '../../shared/components/AppErrorList';
import React, { useEffect, useState } from 'react';
import { SchemaModel } from '../../models/schemaModel';
import { useSelectedSchema } from '../../hooks/useSelectedSchema';
import { useSchemaList } from '../../hooks/useSchemaList';
import { Stack, Typography } from '@mui/material';
import SingleSelect from '../../shared/components/SingleSelect';
import CommitDiffContainer from '../../shared/containers/CommitDiffContainer';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import { CONFIGS_PATH } from '../../routes';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const ConfigsCompareView = () => {
  const navigate = useNavigate();

  const [{ schemas, isLoading, errors }] = useSchemaList();
  const [selectedSchema] = useSelectedSchema();

  const [baseSchema, setBaseSchema] = useState<SchemaModel>();
  const [compareSchema, setCompareSchema] = useState<SchemaModel>();

  useEffect(() => {
    setCompareSchema(selectedSchema);
  }, [selectedSchema]);

  return (
    <Grid container spacing={2}>
      { errors.length > 0 && (
        <Grid item xs={12}>
          <AppErrorList errors={errors} />
        </Grid>
      )}

      <Grid item xs={12}>
        <Stack direction='row' spacing={2} alignItems='center'>
          <IconButton
            aria-label='back to configs view'
            onClick={() => navigate(CONFIGS_PATH)}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant='h5' style={{ margin: '10px 0' }}>Compare changes</Typography>
        </Stack>
      </Grid>

      <Grid item md={8} xs={12}>
        <Stack direction='row' spacing={4} alignItems='center'>
          <SingleSelect
            label='Base schema'
            options={schemas}
            selectOptionId={schema => schema.name}
            selectOptionLabel={schema => schema.name}
            isLoading={isLoading}
            onSelect={setBaseSchema}
          />

          <ArrowCircleLeftIcon />

          <SingleSelect
            label='Compare schema'
            options={schemas}
            selectOptionId={schema => schema.name}
            selectOptionLabel={schema => schema.name}
            defaultOptionId={selectedSchema?.name}
            isLoading={isLoading}
            onSelect={setCompareSchema}
          />
        </Stack>
      </Grid>

      <Grid item xs={12}>
        { baseSchema && compareSchema ? (
          <CommitDiffContainer
            baseCommitId={baseSchema.headCommitId}
            commitId={compareSchema.headCommitId}
          />
        ) : (
          <Alert severity='warning'>Select different schemas above to view and compare changes.</Alert>
        )}
      </Grid>
    </Grid>
  );
};

export default ConfigsCompareView;
